/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialsControllerFindOneQueryResponse, TrialsControllerFindOnePathParams, TrialsControllerFindOneQueryParams, TrialsControllerFindOne400, TrialsControllerFindOne401, TrialsControllerFindOne403, TrialsControllerFindOne404 } from "../../models/trialsController/TrialsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trialsControllerFindOne } from "../../clients/trialsService/trialsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trialsControllerFindOneQueryKey = (id: TrialsControllerFindOnePathParams["id"], params: TrialsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/trials/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TrialsControllerFindOneQueryKey = ReturnType<typeof trialsControllerFindOneQueryKey>;
export function trialsControllerFindOneQueryOptions(id: TrialsControllerFindOnePathParams["id"], params?: TrialsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trialsControllerFindOneQueryKey(id, params);
  return queryOptions<TrialsControllerFindOneQueryResponse, ResponseErrorConfig<TrialsControllerFindOne400 | TrialsControllerFindOne401 | TrialsControllerFindOne403 | TrialsControllerFindOne404>, TrialsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trialsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a trial by id
 * {@link /api/v1/trials/:id}
 */
export function useTrialsControllerFindOne<TData = TrialsControllerFindOneQueryResponse, TQueryData = TrialsControllerFindOneQueryResponse, TQueryKey extends QueryKey = TrialsControllerFindOneQueryKey>(id: TrialsControllerFindOnePathParams["id"], params?: TrialsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrialsControllerFindOneQueryResponse, ResponseErrorConfig<TrialsControllerFindOne400 | TrialsControllerFindOne401 | TrialsControllerFindOne403 | TrialsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trialsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...trialsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrialsControllerFindOne400 | TrialsControllerFindOne401 | TrialsControllerFindOne403 | TrialsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}